import React from 'react';
import CollapsibleItem from '../components/CollapsibleItem';
import * as label from '../constants';
import TimeParentsItem from '../components/TimeParentsItem';
import { updateChildrens } from '../actions/childrens';
import { useSelector, useDispatch } from 'react-redux';
import { timeParentsOptions } from '../constants';
import { updateSection } from '../actions/ui';

const TimeParents = () => {

  const dispatch = useDispatch();
  const equalTimeParents = useSelector((state) => state.parents.equalTimeParents);
  const childrens = useSelector((state) => state.childrens.childrens);
  const childrensCount = useSelector((state) => state.childrens.childrensCount);
  const parents = useSelector((state) => state.parents.parents);


  const updateInfoTime = (index,values) => {
    dispatch(updateChildrens(index,'timeParent1',values[0]));
    dispatch(updateChildrens(index,'timeParent2',values[1]));
    dispatch(updateSection(label.sectionIds.TIME_WITH_PARENTS));

  }

  const updateUnitTimes = (index,option) => {
    if (childrens[index].timeUnitIndex!==option){
      dispatch(updateChildrens(index,'timeUnitIndex',option));
      dispatch(updateSection(label.sectionIds.TIME_WITH_PARENTS));
    }
  }


  const renderContent = () => {
    if (equalTimeParents || (childrensCount===1)) return (
      <TimeParentsItem
        isCollapsible={false}
        parents={parents}
        onUpdateTimes={(v) => updateInfoTime(0,v)}
        onUpdateUnit={(o) => updateUnitTimes(0,o)}
        initialValues={[childrens[0].timeParent1,childrens[0].timeParent2]}
        initialOption={timeParentsOptions[childrens[0].timeUnitIndex]}
      />
    )

    return childrens.map((item,index) => {
      if (index < childrensCount) return (
      <TimeParentsItem
        {...item}
        parents={parents}
        key={index}
        onUpdateTimes={(v) => updateInfoTime(index,v)}
        onUpdateUnit={(o) => updateUnitTimes(index,o)}
        initialValues={[item.timeParent1,item.timeParent2]}
        initialOption={timeParentsOptions[item.timeUnitIndex]}
      />
      )
    })
  }

  return (
    <CollapsibleItem
      id={label.sectionIds.TIME_WITH_PARENTS}
      isForm={equalTimeParents || (childrensCount===1)}
    >
       {renderContent()} 
    </CollapsibleItem>
  )
}

export default TimeParents;
